import "./App.css";
import Header from "./header/header";
import Home from "./build/home/home";
import About from "./build/about/about";
import Project from "./build/projects/projects";
import Skills from "./build/skills/skills";
import Contact from "./build/contact/contact";
import Footer from "./footer/footer";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Header />
      <Home />
      <About />
      <Project />
      <Skills />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
